<template>
  <settings-element>
    <template #title>Border Radius</template>
    <template #body>
      <BorderRadius :variable="variable" />
    </template>
  </settings-element>
</template>

<script>
import SettingsElement from "@/components/campaign-builder/widget-settings/SettingsElement"
import BorderRadius from "@/components/campaign-builder/appearance-changers/BorderRadius"

export default {
  name: "SettingsBorderRadius",
  props: {
    variable: {
      type: String,
      required: true
    }
  },
  components: { BorderRadius, SettingsElement }
}
</script>
